module.exports = __webpack_public_path__ + "static/img/2673_phase_function_Paper_Points.1dce039.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/2673_phase_function_Paper_Points.png
// module id = ysKW
// module chunks = 0